export var sendingDomainUri = 'sendingDomain';
export var sendingDomainsUri = 'sendingDomains';
export var emailNotificationUri = 'emailNotifications';
export var createEmailDomainApi = function (baseUrl, http) {
    var newSendingDomainApi = {
        getAllSendingDomains: function () { return http.get(baseUrl + "/" + sendingDomainsUri); },
        getSendingDomain: function (id) { return http.get(baseUrl + "/" + sendingDomainsUri + "/" + id); },
        addSendingDomain: function (domain) { return http.post(baseUrl + "/" + sendingDomainsUri, { domain: domain }); },
        deleteSendingDomain: function (id) { return http.delete(baseUrl + "/" + sendingDomainsUri + "/" + id); },
        validateSendingDomain: function (id) { return http.get(baseUrl + "/" + sendingDomainsUri + "/" + id + "/isValid"); },
        setDefaultSendingDomain: function (id) { return http.post(baseUrl + "/" + sendingDomainsUri + "/" + id + "/default", {}); },
        editSendingDomain: function (dto) { return http.post(baseUrl + "/" + sendingDomainsUri + "/" + dto.id + "/edit", dto); },
    };
    return {
        getCustomSendingDomain: function () {
            return http.get(baseUrl + "/" + emailNotificationUri + "/" + sendingDomainUri);
        },
        setCustomSendingDomain: function (domainName) {
            return http.post(baseUrl + "/" + emailNotificationUri + "/" + sendingDomainUri + "?domain=" + domainName, {});
        },
        validateCustomSendingDomain: function () {
            return http.post(baseUrl + "/" + emailNotificationUri + "/" + sendingDomainUri + "/validate", {});
        },
        deleteCustomSendingDomain: function () {
            return http.delete(baseUrl + "/" + emailNotificationUri + "/" + sendingDomainUri);
        },
        sendingDomains: newSendingDomainApi,
    };
};
//# sourceMappingURL=index.js.map